module.exports = __webpack_public_path__ + "static/media/testimonial_image.3eca2a48.jpg";